module.exports = __webpack_public_path__ + "img/no-img.6039d3e.png";